var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"page-container",attrs:{"id":"join-loading"}},[_c('div',{staticClass:"mbrp-loading"},[_c('strong',{staticClass:"color-orange"},[_vm._v("통합 로그인 진행중 입니다")]),_c('p',[_vm._v("잠시만 기다려 주세요")]),_c('div',{staticClass:"loading-container is-active"},[_c('div',{staticClass:"loading"})])])])
}]

export { render, staticRenderFns }